<template>
  <ListPrompts></ListPrompts>
</template>
<script>
import ListPrompts from "@/components/IAReputation/ListPrompts.vue"

export default {
  components: {ListPrompts}
}

</script>
